/** Shared builds identify the organisation from the browser URL before config or SSO runs. */
export function sharedOrgSlug(): string | null {
  if (typeof window === 'undefined') return null
  if (window.location.hostname !== 'bookings.hospora.app' && import.meta.env.VITE_HOSPORA_SHARED !== 'true') return null
  const slug = window.location.pathname.split('/')[1] ?? ''
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) && slug !== '_hospora' ? slug : null
}
export function apiBaseUrl(): string {
  const slug = sharedOrgSlug()
  return slug ? `${window.location.origin}/${slug}/api` : import.meta.env.VITE_API_URL || 'http://localhost:8787'
}
export function routerBase(staff = false): string {
  const slug = sharedOrgSlug()
  return slug ? `/${slug}${staff ? '/admin' : ''}/` : '/'
}
export function storageKey(key: string): string {
  const slug = sharedOrgSlug()
  return slug ? `hospora:${slug}:${key}` : key
}
